export abstract class Selectable {
    public content: string;
    public selected: boolean;
    public key: string;

    constructor(content: string, key: string) {
        this.content = content;
        this.selected = false;
        this.key = key;
    }
}
